import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import get from 'lodash/get';
import * as styles from './CouponCard.css';

const cx = classNames.bind(styles);

class CouponSavings extends Component {
    static propTypes = {
        couponData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        couponAnimation: PropTypes.bool,
        applyCouponRequest: PropTypes.string,
    };

    static defaultProps = {
        couponData: [],
        inlineMessaging: false,
        couponAnimation: false,
        applyCouponRequest: '',
    };

    render() {
        const { couponData, couponAnimation, applyCouponRequest } = this.props;

        let couponHeader = null;
        /* istanbul ignore if */
        if (couponData.content && couponData.content.totalDiscount > 0) {
            const couponApplied = get(couponData, 'content.id', '');
            let showCouponSaveMsg = true;
            if (couponAnimation) {
                const selectedCoupon = get(this.props, 'couponApplicationState.selectedCouponCode');
                const couponPromo = get(couponData, 'content.promoCode', false);
                const redeemingChannel = get(couponData, 'content.redeemingChannel');
                const errorMsgLen = get(this.props, 'couponPopupMessages.length', 0);
                const isSuccessMsg = couponPromo && couponApplied && redeemingChannel !== 'instore';
                const isErrorMsg = errorMsgLen > 0 && selectedCoupon === couponPromo;
                const isCouponSaveMsg = !(isSuccessMsg || isErrorMsg);
                showCouponSaveMsg = !applyCouponRequest && isCouponSaveMsg;
            }
            couponHeader = (
                <div
                    className={cx('greatSavingsBlock')}
                    data-automation-id="at-great-savings-block"
                >
                    {showCouponSaveMsg && (
                        <div
                            className={cx('greatSavingDesc', {
                                drawerCouponApplied: couponAnimation,
                            })}
                        >
                            <h5
                                className={cx('greatSavingTitle')}
                                data-automation-id="at-best-coupons-savings-label"
                            >
                                {couponApplied ? 'You Are Saving' : 'Save'} $
                                {couponData.content.totalDiscount.toFixed(2)}
                            </h5>
                            {/* <h5 className={cx('greatSavingTitle')} data-automation-id="at-best-coupons-savings-label">
                            on the items in your cart
                        </h5> */}
                        </div>
                    )}
                </div>
            );
        }

        return <>{couponHeader}</>;
    }
}

export default CouponSavings;
